<ng-container *ngIf="visible$ | async">
  <button *ngIf="isExtendedOpen" class="azt-fab_backdrop" (click)="closeExtended()"></button>
  <div class="azt-fab_wrapper" [ngStyle]="!!(buttonsOverlap && fabButtonBottomPosition) ? {'bottom': fabButtonBottomPosition + 'px'} : null">
    <button *ngIf="!isExtendedOpen" class="azt-fab" (click)="openExtended()" #fabButton>
      <nx-icon class="azt-fab--mobile" name="info-circle" />
      <span class="azt-fab_text azt-fab--desktop">{{ 'common.HELP_BUTTON' | translate }}</span>
    </button>
    <div class="azt-fab_extended" *ngIf="isExtendedOpen">
      <button class="azt-fab_button" (click)="openContact()">
        <nx-icon class="azt-fab_icon" name="phone-o" />
        <span class="azt-fab_text">{{ 'common.CALLBACK_BUTTON' | translate }}</span>
      </button>
      <button class="azt-fab_close" (click)="closeExtended()">
        <nx-icon name="close" />
      </button>
    </div>
  </div>
</ng-container>
